<template>
    <TxProductViewPortal>
        <love-map-loader>
            <div class="lm-index" :class="[mapLayout,$root.env]">
                <TxZoomControl
                        v-model="zoom"
                        :disabled="mapBlock"
                        :mapLayout="mapLayout"
                />
                <TxZoomBlocker
                        v-model="mapBlock"
                        :mapLayout="mapLayout"
                />
                <TxBlockOverlay :active="mapBlock">
                    <TxRendererProduct
                            componentName="TxProductBorder"
                            :mapLayout="mapLayout"
                            :size="mapSize"
                    >
                        <LoveMapProduct/>
                    </TxRendererProduct>
                </TxBlockOverlay>
            </div>
        </love-map-loader>
    </TxProductViewPortal>
</template>


<script>
    import LovemapModule from "@packages/tx-products/products/lovemap/store-mixin";

    export default {
        name: 'LoveMapIndex',
        mixins: [LovemapModule()],
        data() {
            return {
                mapBlock: false,
            }
        },
        mounted() {
            if (this.$root.env === 'admin') {
                this.mapBlock = true;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .lm-index {
        background: url(./assets/lm-background.webp);
        background-size: cover;
        position: relative;

        &.admin {
            //padding-top: 40px !important;
            padding-bottom: 40px !important;
        }

        &.horizontal {
            background: none;
        }

        @media (max-width: 599px) {
            padding-bottom: 20px;
            background: none;
        }
        @media (min-width: 600px) {
            &.vertical {
                padding-top: 20px;
            }
        }
    }

</style>
